import {IWizardStep} from './wizardStep.ctrl';

export interface IWizardStepManager {
    isActiveStep(step: IWizardStep): boolean;
    registerStep(step: IWizardStep): void;
    validateStep(step: IWizardStep, updateUiFields: boolean): string;
}

export abstract class WizardStepManagerController implements ng.IController, IWizardStepManager {

    public steps: IWizardStep[] = [];
    public currentStepIndex = -1;
    public canGoToNext = false;
    public canGoToPrev = false;
    public canConfirm = false;
    public showNext = false;
    public showPrev = false;
    public showConfirm = false;
    public validatingMessage = '';

    constructor(public $scope: ng.IScope) {
    }

    public $onInit() {
    }

    public $doCheck() {
        this.validateCurrentStep();
    }

    public isActiveStep(step: IWizardStep): boolean {
        return (this.currentStepIndex > -1 && this.currentStepIndex === this.steps.indexOf(step));
    }

    public registerStep(step: IWizardStep): void {
        if (this.steps.indexOf(step) > -1) {
            return;
        }
        let idx = 0;
        for ( ; idx < this.steps.length; idx++) {
            if (step.displayOrder < this.steps[idx].displayOrder) {
                break;
            }
        }
        this.steps.splice(idx, 0, step);

        if (this.currentStepIndex < 0) {
            this.currentStepIndex = 0;
        }
        this.updateStatus();
    }

    public validateCurrentStep() {
      const currentStep = this.steps[this.currentStepIndex];
      if (currentStep != null && this.validateStep(currentStep, true)) {
        return;
      }
      this.updateStatus();
    }

    public validateStep(step: IWizardStep, touchErrorUiFields: boolean): string {
        this.validatingMessage = step.validate(touchErrorUiFields);
        this.updateStatus();
        return this.validatingMessage;
    }

    public goToNext() {
        this.validateCurrentStep();
        const step = this.steps[this.currentStepIndex];
        if (step.isValidated && this.currentStepIndex < this.steps.length) {
            this.currentStepIndex ++;
        }
        this.updateStatus();
    }

    public goToPrev() {
        if (this.currentStepIndex > 0) {
            this.currentStepIndex --;
        }
        this.validateStep(this.steps[this.currentStepIndex], true);
        this.updateStatus();
    }

    public confirm(): boolean {
        return !this.validateStep(this.steps[this.currentStepIndex], true);
    }

    public updateConfirmStatus() {
        this.canConfirm = this.currentStepIndex === this.steps.length - 1;
    }

    public getPrevText() {
        return ((this.currentStepIndex > -1) ? this.steps[this.currentStepIndex].getPrevText() : '') || 'Prev';
    }

    public getNextText() {
        return ((this.currentStepIndex > -1) ? this.steps[this.currentStepIndex].getNextText() : '') || 'Next';
    }

    public getConfirmText() {
        return ((this.currentStepIndex > -1) ? this.steps[this.currentStepIndex].getConfirmText() : '') || 'Confirm';
    }

    public showStep(step: IWizardStep) {
        const targetStepIndex = this.steps.indexOf(step);
        if (targetStepIndex < this.currentStepIndex) {
            this.currentStepIndex = targetStepIndex;
            this.validateStep(this.steps[this.currentStepIndex], false);
        }
        if (targetStepIndex > this.currentStepIndex) {
            if (targetStepIndex - this.currentStepIndex === 1) {
              this.validateCurrentStep();
              const currentStep = this.steps[this.currentStepIndex];
              if (currentStep.isValidated) {
                  this.currentStepIndex = targetStepIndex;
              }
            }
        }
        this.updateStatus();
    }

    protected updateStatus() {
        const currentStep = this.steps[this.currentStepIndex];
        this.steps.forEach((step, index) => { step.show( index === this.currentStepIndex); });
        this.canGoToPrev = this.currentStepIndex > 0;
        this.canGoToNext = (this.currentStepIndex < this.steps.length - 1) && currentStep.isValidated;
        this.showPrev = this.currentStepIndex !== 0;
        this.showNext = this.currentStepIndex < this.steps.length - 1;
        this.showConfirm = this.currentStepIndex === this.steps.length - 1;
        this.updateConfirmStatus();
    }
}
